import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react'
import config from '../../../config'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Dropdown from 'react-bootstrap/Dropdown';
import '../css/navbar.css'
import Cookies from "js-cookie";
import { useDisconnect } from 'wagmi';
import { useDispatch, useSelector } from 'react-redux';
import * as ACTIONTYPES from '../../../redux/actionTypes'



const GeneralNavbar = () => {
  const [isSticky, setIsSticky] = useState(false);


  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);




  const _useDisconnect = useDisconnect();
  const dispatch = useDispatch();
  let loginData = (!Cookies.get('InfiUser')) ? [] : JSON.parse(Cookies.get('InfiUser'));


  const disconnectWallet = () => {
      _useDisconnect.disconnect()
      dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
      console.log('Wallet disconnected')
  }

  const logout = () => {
    Cookies.remove("InfiUser")
    disconnectWallet()
    console.log('log',loginData.length)
    console.log('Wallet disconnected')
    //window.location.reload()
  }

  const login = () => {
    window.location.href = `${config.baseurl}login`
  }

  return (


    <div className={`headerico ${isSticky ? 'sticky' : ''}`}>
      {['xl'].map((expand) => (
        <Navbar key={expand} expand={expand} className="mb-3 mt-3 py-0" >
          <Container>
            <Navbar.Brand href="#" className='text-white'><img src='assets/images/logo/logo.svg' width="170px" /></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <img src='assets/images/logo/logo.svg' width="170px" />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-center flex-grow-1 pe-3">
                  {/* <Nav.Link href="javascript:void(0)">How It Works</Nav.Link> */}
                  <Nav.Link href={`${config.baseurl}Aboutus`} >About Us</Nav.Link>
                  <Nav.Link href="#FAQ">FAQs</Nav.Link>

                </Nav>
                <Form className="d-md-flex">

                  {/* <Button variant="default" className='me-3 border-0 border-blue bg-transparent btn-login' onClick={event => window.location.href=`${config.baseurl}login`}>Login</Button> */}
                  { loginData.length <= 0 ? ( <Button variant="default" className='me-3 border-0 border-blue bg-transparent btn-login' onClick={login}> Login</Button> ) :(<Button variant="default" className='me-3 border-0 border-blue bg-transparent btn-login' onClick={logout}>  Logout</Button> ) } 
                  {/* <Button variant="blue" className='me-3 border-blue'>ICO</Button> */}
                  {/* <Dropdown>
                    <Dropdown.Toggle variant="default" id="dropdown-basic" className='border-blue'>
                      <img src="assets/images/ico/icon/united-states.png" className='me-3' />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </Form>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </div>

  );
}

export default GeneralNavbar